<template>
	<div id="plans" class="pb-sm-2">
		<v-fab-transition>
			<v-btn
				v-if="
					!isSelectedDayWeekend && (
          (
						!loading &&
						moment(selectedMonth, 'YYYY-MM').diff(moment().format('YYYY-MM'), 'months') > 0 &&
						moment(selectedMonth, 'YYYY-MM').diff(moment(activePlan.fromDate).format('YYYY-MM'), 'months') === 0 &&
						!weeklyPlan &&
            lockPlanBeforeDays === undefined
					) ||
					(
						!loading &&
						weeklyPlan &&
						lockPlanBeforeDays === 0 &&
						moment(selectedDay).isSameOrAfter(moment(), 'day')
					)
					||
          (
						!loading &&
						!weeklyPlan &&
						lockPlanBeforeDays === 0 &&
						moment(selectedDay).isSameOrAfter(moment(), 'day')
					)
					|| (!weeklyPlan && (lockPlanBeforeDays === null || lockPlanBeforeDays === undefined) && moment(selectedDay).isAfter(moment(moment().endOf('month')), 'day'))
          ||
					(weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(endOfCurrentWeek), 'day')) ||
          (lockPlanBeforeDays > 0 && moment(selectedDay).isSameOrAfter(moment().add(lockPlanBeforeDays, 'day'), 'day'))
					)
				"
				fab
				fixed
				bottom
				:right="$i18n.locale !== 'ar'"
                :left="$i18n.locale === 'ar'"
				direction="left"
				color="primary"
				:class="['mb-15', { 'sale-system-add-fab': usePrices }]"
				@click="planningVisitSheet = true"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			<!--  -->

			<v-speed-dial
				v-if="0"
				v-model="buttonsOptions"
				fixed
				bottom
				right
				direction="left"
				transition="slide-x-reverse-transition"
				class="mb-15"
			>
				<template v-slot:activator>
					<v-btn
						v-if="!loading"
						v-model="buttonsOptions"
						fab
						color="primary"
					>
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>

				<v-btn
					fab
					color="success"
					small
					@click="planningVisitSheet = true"
				>
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<v-btn
					fab
					small
					color="deep-purple white--text"
					:disabled="!planningVisits.length"
					@click="''"
				>
					<v-icon>mdi-content-save</v-icon>
				</v-btn>
			</v-speed-dial>
		</v-fab-transition>

		<!-- delete dialog declaered here to use it as ref -->
        <delete-dialog ref="DeleteDialog" @on-delete="fetchPlannedVisits">
            <template v-slot:default>
				<p
					class="mb-0 text-body-1"
					v-html="$T('messages.are-you-sure-you-want-to-delete-$', { text: $T('the-planned-visit') })"
				/>
            </template>
        </delete-dialog>

		<!-- add sheet -->
		<v-bottom-sheet v-model="planningVisitSheet" persistent>
			<v-card>
				<v-toolbar dark flat color="primary" class="text-uppercase">
					<v-spacer/>

					<v-spacer/>
					<v-toolbar-items text>
						<v-btn small text @click="planningVisitSheet = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-form @submit.prevent="submit" ref="form" :disabled="submitLoading">
                    <!-- chip group -->
					<v-chip-group
						v-if="customersTypes.length"
						v-model="sheetData.directoryType"
						show-arrows
						center-active
						active-class="success"
						class="d-flex justify-center pt-0"
						mandatory
						@change="sheetData.regionId = sheetData.entityId = null"
					>
						<v-chip
							v-for="(type, index) in customersTypes"
							:key="index"
							:value="type.id"
							class="rounded-xl"
						>
							{{ type.name }}
						</v-chip>
					</v-chip-group>

                    <!-- card content -->
                    <v-card-text class="pb-0">
						<v-row dense>
							<!-- region -->
							<v-col md="6" cols="12">
								<v-autocomplete
									v-model="sheetData.regionId"
									:items="regions"
									item-text="name"
									item-value="id"
									:label="$T('inputs.region')"
									:rules="rules.required"
									hide-details="auto"
									@change="fetchEntities(); sheetData.entityId = null"
								></v-autocomplete>
							</v-col>

							<!-- entity -->
							<v-col md="6" cols="12">
								<v-autocomplete
									v-model="sheetData.entityId"
									:items="entities"
									item-text="name"
									item-value="id"
									:multiple="!plannedVisitId"
									:label="$T('inputs.customer-name')"
									chips
									small-chips
									deletable-chips
									:rules="rules.required"
									hide-details="auto"
									:loading="entitiesLoading"
									:disabled="entitiesLoading || !sheetData.regionId || submitLoading"
								></v-autocomplete>
							</v-col>

							<!-- materials -->
							<template v-if="useMaterialsPlan">
								<v-col cols="12">
									<span class="text-body-1">Materials</span>
									<v-btn
										icon
										@click="sheetData.plannedMaterials.push({
											id: sheetData.plannedMaterials.length,
											materialId: null,
											amount: null
										})"
									>
										<v-icon>mdi-plus-circle-outline</v-icon>
									</v-btn>
								</v-col>
								<v-col v-for="(item, index) in sheetData.plannedMaterials" :key="index" cols="12">
									<v-row dense align="center">
										<!-- material -->
										<v-col cols="7">
											<v-autocomplete
												v-model="item.materialId"
												:items="allMaterials"
												:label="$T('inputs.material')"
												item-text="name"
												item-value="id"
												dense
												hide-details
												:rules="rules.required"
											/>
										</v-col>

										<!-- amount -->
										<v-col cols="3">
											<v-text-field
												v-model.number="item.amount"
												:label="$T('inputs.amount')"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												hide-details
												:rules="rules.requiredAsNumber"
											/>
										</v-col>

										<!-- remove -->
										<v-col cols="auto">
											<v-btn
												icon
												@click="
													sheetData.plannedMaterials.splice(index, 1);
													sheetData.plannedMaterials.forEach((c, i) => {
														if (c.id >= item.id) sheetData.plannedMaterials[i].id--;
													})
												"
											>
												<v-icon>mdi-minus-circle-outline</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
							</template>

							<!-- date -->
							<v-col md="6" cols="12" class="d-flex">
								<div class="d-flex flex-column align-start justify-start me-1">
									<v-icon size="24" class="mx-1" :color="isHoliday === 'error' ? '#F4511E' : ''">mdi-calendar</v-icon>
									<span v-if="isHoliday === 'error'" style="color: #F4511E" class=" fs-sm">Holiday </span>
								</div>
								<v-menu
									v-model="dateMenu"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="sheetData.date"
											:label="$T('inputs.date')"
											:rules="rules.required"
											hide-details="auto"
											readonly
											v-bind="attrs"
											v-on="on"
                      disabled
										></v-text-field>
									</template>

									<v-date-picker
										v-model="sheetData.date"
										:min="moment().format('YYYY-MM-DD')"
										@input="dateMenu = false"
										@change="getHoliday(sheetData.date)"
									></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
						<v-btn
							color="success"
							text
							type="submit"
							:loading="submitLoading"
							:disabled="submitLoading"
						>
							{{$T('save')}}
						</v-btn>
						<v-btn color="grey darken-1" text @click="planningVisitSheet = false">
							{{$T('close')}}
						</v-btn>
					</v-card-actions>
                </v-form>
			</v-card>
		</v-bottom-sheet>

		<!-- filter -->
        <v-card flat color="lightgray">
            <!-- date -->
            <v-card-text class="d-flex justify-space-between align-center">
				<!-- {{ plans }} -->
                <!-- date dialog -->
                <v-dialog
					v-model="dialog"
                    ref="dialog"
                    :return-value.sync="selectedMonth"
                    persistent
                    max-width="300px"
                >
                    <!-- date text -->
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex justify-space-between align-center primary--text "
                        >
                            <div class="d-flex align-center">
                                <v-icon class="me-2" color="primary">mdi-calendar</v-icon>
                                <span class="text-h5 me-2">{{ dateHeaderLabel }}</span>
								<span class="text-subtitle-2 align-self-end">{{moment(selectedDay || selectedMonth).format('YYYY')}}</span>
                            </div>
                        </div>
                    </template>
                    <!-- dialog date picker -->
                    <v-date-picker
                        v-model="selectedMonth"
                        full-width
                        picker-date
						type="month"
                        :max="moment().add(1, 'month').format('YYYY-MM-DD')"
						@change="selectedDay = undefined"
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="dialog = false"
                        >
                            {{$T('cancel')}}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="update()"
                        >
                            {{$T('ok')}}
                        </v-btn>
                    </v-date-picker>
                </v-dialog>

				<!-- today button -->
				<v-btn
					text
					small
					color="primary"
					@click="goToTodayDate"
				>
					{{$T('components.today')}}
				</v-btn>
            </v-card-text>
        </v-card>

		<!-- date picker -->
		<div class="d-flex align-center mb-4">
			<v-btn
				depressed
				min-width="0"
				height="48"
				class="mx-2 py-0 px-2 rounded-sm transparent"
				:class="{ secondary: !selectedDay }"
				@click="selectedDay = undefined"
			>{{$T('all')}}</v-btn>
			<v-day-date
				v-if="weeklyPlan"
				v-model="selectedDay"
				:month="selectedMonth"
				:max-width="
					$vuetify.breakpoint.width -
					(isTouchDevice ? 52 : 70) -
					($i18n.locale === 'ar' ? 34 : 10)
				"
				:optional="false"
				@change="selectedDay = $event; updateDate()"
				:disabled="loading"
			></v-day-date>

			<v-month-days
				v-else
				v-model="selectedDay"
				:month="selectedMonth"
				:vacations="vacations"
				:vacation-day-details="vacationsDayDetails"
				:max-width="
					$vuetify.breakpoint.width -
					(isTouchDevice ? 52 : 70) -
					($i18n.locale === 'ar' ? 34 : 10)
				"
			></v-month-days>
		</div>

		<!-- cards -->
		<loader v-if="loading"/>
		<v-row v-else :no-gutters="$vuetify.breakpoint.xs" dense class="mx-2">
			<v-col
				v-for="(plannedVisit, index) in filteredPlanningVisits"
				:key="plannedVisit.id"
				lg="3" md="4" sm="6" cols="12"
				class="planned-visit__container mb-sm-0 mb-3"
				:class="{ 'mb-16': index === filteredPlanningVisits.length - 1 }"
			>
				<!-- deleteFab -->
				<v-fab-transition>
					<v-btn
						v-if="!plannedVisit.isAdministrativeDouble && deleteButtonFab && plannedVisitId === plannedVisit.id"
						fab
						absolute
						left
						dark
						small
						text
						:width="14"
						color="red darken-2"
						class="planned-visit__action-btn"
					>
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</v-fab-transition>
				<!-- && !plannedVisit.isOutPlan -->
				<v-card
					v-touch="
						!plannedVisit.isAdministrativeDouble && isPlannedVisitOutOfActivePlan(plannedVisit.id)
						? {
							move: (e) => { plannedVisitId = plannedVisit.id; touchMove(e); },
							end: (e) => { endOffset(e) }
						}
						: {}
					"
					elevation="4"
					class="planned-visit__card"
					:style="
						(deleteButtonFab || editButtonFab) && plannedVisitId === plannedVisit.id
							? { transform: `translateX(${touchSwipeOffset}px)` }
							: null
					"
				>
					<v-card-text class="d-flex align-center pa-2">
						<div
							class="white--text rounded py-2 px-3 text-capitalize"
							:class="[
								{ 'success': plannedVisit.isVisited },
								plannedVisit.isOutPlan
									? 'orange darken-1'
									: !plannedVisit.isVisited
										? moment(plannedVisit.date).diff(moment(), 'days') < 0
											? 'red lighten-1'
											: 'grey darken-2'
										: null
							]"
						>
							{{ plannedVisit.isAdministrativeDouble ? 'D.V' : getEntityTypeName(plannedVisit.entity.entityTypeId) }}
						</div>
						<p class="ms-4 mb-0">{{ plannedVisit.entity?.name || plannedVisit.workDescription || 'D.V' }}</p>
						<v-spacer/>
						<!-- {{ plannedVisitId }}
						<br />
						{{ plannedVisit.id }} -->
						<span class="primary--text pe-1">{{plannedVisit.date}}</span>

						<!-- delete button for planning state -->
								<!-- !plannedVisit.isOutPlan -->
						<template
							v-if="
								!plannedVisit.isAdministrativeDouble && (
									(
										!isTouchDevice &&
										!loading &&
										moment(selectedMonth, 'YYYY-MM').diff(moment().format('YYYY-MM'), 'months') > 0 &&
										moment(selectedMonth, 'YYYY-MM').diff(moment(activePlan.fromDate).format('YYYY-MM'), 'months') === 0 &&
										!weeklyPlan
									)
									||
									(
										!isTouchDevice &&
										!loading &&
										weeklyPlan &&
										lockPlanBeforeDays === 0 &&
										moment(selectedDay).isSameOrAfter(moment(), 'day')
									)
									||
									(!isTouchDevice && weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(endOfCurrentWeek), 'day'))
									||
									(!isTouchDevice && !weeklyPlan && lockPlanBeforeDays === null && moment(selectedDay).isAfter(moment(moment().endOf('month')), 'day'))
									||
									(!isTouchDevice && lockPlanBeforeDays !== null && moment(selectedDay).isSameOrAfter(moment(activePlan.fromDate).add(lockPlanBeforeDays, 'day'), 'day'))
								)
							"
						>
								<!-- isPlannedVisitOutOfActivePlan(plannedVisit.id) && -->
							<v-btn icon @click="plannedVisitId = plannedVisit.id;  fillDateToEdit()">
								<v-icon color="success">mdi-pencil</v-icon>
							</v-btn>
							<v-btn
								icon
								@click="
									plannedVisitId = plannedVisit.id;
									$refs.DeleteDialog.activeDialog(plannedVisitId, 'plannedVisits')
								"
							>
								<v-icon color="red lighten-1">mdi-delete</v-icon>
							</v-btn>
						</template>
						<v-btn
							v-if="false && planningVisit.isInPlanningState"
							icon
							@click="removePlanningVisit(planningVisit.id)"
						>
							<v-icon color="red lighten-1">mdi-delete</v-icon>
						</v-btn>
					</v-card-text>
				</v-card>

				<!-- EditFab -->
				<v-fab-transition>
					<v-btn
						v-if="!plannedVisit.isAdministrativeDouble && editButtonFab && plannedVisitId === plannedVisit.id"
						fab
						absolute
						right
						dark
						small
						text
						:width="14"
						color="success darken-2"
						class="planned-visit__action-btn"
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</v-fab-transition>
			</v-col>

			<v-col
				v-if="!filteredPlanningVisits.length"
				cols="12"
				class="d-flex flex-column justify-center align-center grey--text text-body-1"
				style="height: 45vh"
			>
				<v-icon x-large class="mb-3">mdi-alert-circle-outline</v-icon>
				{{$T('no-planned-visits-for-this-day')}}
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import DeleteDialog from '../components/DeleteDialog'
import { mapGetters, mapState } from 'vuex';
// import { entityType } from '@/helpers/enums'
import { getEntityNameByType, isTouchDevice, getWeekRange, getDateColor } from '@/helpers/functions'
import rules from '@/helpers/validation rules';
import moment from 'moment';
import { useMaterialsPlan, deletionExternal, usePrices } from '@/configs/general.configs'
import VDayDate from '@/components/VDayDate.vue';
import VMonthDays from '@/components/VMonthDays.vue';

export default {
	name: 'Plans',

	components: {
		DeleteDialog,
		VDayDate,
		Loader,
		VMonthDays
	},

	data: () => ({
		// helpers
		loading: false,
		submitLoading: false,
		entitiesLoading: false,

		buttonsOptions: false,
		dialog: false,
		planningVisitSheet: false,

		dateMenu: null,
		selectedDay: moment().format('YYYY-MM-DD'),
		selectedMonth: moment().format('YYYY-MM'),

		rules,
		// entityType,
		entities: [],

		// configs
		useMaterialsPlan,
		usePrices,
		deletionExternal,

		// out of plan visits
		notPlannedVisits: [],
		administrativeDoubleVisits: [],

		// swipe card
		plannedVisitId: null,
		touchSwipeOffset: 0,
		deleteButtonFab: false,
		editButtonFab: false,

		// data
		planningVisitsCounter: 0,
		planningVisits: [],
		sheetData: {
			directoryType: null,
			regionId: null,
			entityId: null,
			date: moment().format('YYYY-MM-DD'),
			plannedMaterials: [],
		},

		allEntities: [],
		planCreatedId: null,

		isHoliday: null
	}),

	watch: {
		/*
		planningVisits: {
			handler: function (newVal) {
				localStorage.setItem('planning-visits', JSON.stringify(newVal));
			},
			deep: true
		},
		*/

		planningVisitSheet(newVal) {
			if (!newVal) {
				if (this.$refs.form) this.$refs.form.resetValidation();
				this.sheetData.directoryType = null;
				this.sheetData.regionId = null;
				this.sheetData.entityId = null;
				this.sheetData.plannedMaterials = [];

				this.plannedVisitId = null;
			} else {
				// this.getHoliday(this.sheetData.date)
				this.sheetData.date = this.selectedDay || moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD');
			}

			if (newVal && !this.customersTypes.length) {
				this.$store.dispatch('entities/fetchEntityType');
			}
		}
	},

	computed: {
		dateHeaderLabel() {
			if (!this.selectedDay) return moment(this.selectedMonth).format('MMMM');

			const isToday = this.selectedDay === moment().format('YYYY-MM-DD');
			const dayLabel = isToday ? this.$T('components.today') : moment(this.selectedDay, 'YYYY-MM-DD').format('dddd');

			return `${dayLabel}, ${moment(this.selectedDay, 'YYYY-MM-DD').format('DD MMMM')}`;
		},

		...mapState({
			self: state => state.auth.self,
			allMaterials: state => state.materials.materials,
			plans: state => state.plans.plans,
			plannedVisits: state => state.plannedVisits.plannedVisits,
			activePlan: state => state.plans.activePlan,
			regions: state => state.regions.regions,
			vacations: state => state.vacations.vacations,
			vacationsDayDetails: state => state.vacations.vacationsDayDetails,
			customersTypes: state => deletionExternal ? state.entities.customersTypes.filter(c => c.name !== 'Externals') : state.entities.customersTypes,
			weeklyPlan: state => state.configurations.weeklyPlan,
			lockPlanBeforeDays: state => state.configurations.lockPlanBeforeDays,
			weekendCompany: state => state.configurations.systemConfigValue?.properties?.find(c => c.key === 'weekend')?.value
		}),

		...mapGetters({
			getEntityById: 'entities/getEntityById',
			getPlanById: 'plans/getPlanById',
			getPlannedVisitById: 'plannedVisits/getPlannedVisitById',
		}),

		filteredPlanningVisits() {
			const administrativeDoubleVisitRows = this.administrativeDoubleVisits
				.map(c => {
					const date = moment(c.date || c.createdAt || c.visitDate).format('YYYY-MM-DD')
					if (!date || date === 'Invalid date') return null

					return {
						...c,
						id: `dv-${c.id || date}`,
						date,
						isAdministrativeDouble: true,
						isOutPlan: false,
						entity: {
							name: c.workDescription || 'D.V',
							entityType: null,
						}
					}
				})
				.filter(Boolean)

			return [
				...this.plannedVisits.filter(c => {
					// filter planned visits due to plan
					const plan = this.getPlanById(c.visitPlanId);
					return moment(c.date).isBetween(plan.fromDate, plan.toDate, 'days', '[]');
				}).map(c => ({ ...c, date: moment(c.date).format('YYYY-MM-DD') })),

				...this.notPlannedVisits,
				...administrativeDoubleVisitRows
			].filter(c => {
				if (!this.selectedDay) return c.date.includes(this.selectedMonth);
				else return c.date === this.selectedDay;
			}).sort((a, b) => {
				const diff = moment(a.date).diff(b.date, 'days');
				if (diff > 0) return -1;
				else if (diff < 0) return 1;
				return 0;
			});
		},

		/*
		todayDateText() {
			if (!this.selectedDay) return 'All';
			const todayDate = moment().format('YYYY-MM-DD');
			return todayDate === this.selectedDay ? 'Today' : moment(this.selectedDay).format('ddd');
		},
		*/

		isTouchDevice,
		getWeekRange,

		startOfCurrentWeek() {
			return getWeekRange(this.moment())?.start
		},

		endOfCurrentWeek () {
			return getWeekRange(this.moment())?.end
		},

		// true when the selected day falls on the configured weekend day (Sunday=0 ... Saturday=6)
		isSelectedDayWeekend() {
			if (this.weekendCompany === undefined || this.weekendCompany === null || this.weekendCompany === '') return false
			return Boolean(this.selectedDay) && moment(this.selectedDay).day() === Number(this.weekendCompany)
		},

		administrativeDoubleVisitDates() {
			return this.administrativeDoubleVisits
				.map(c => {
					const date = moment(c.date || c.createdAt || c.visitDate).format('YYYY-MM-DD')
					if (!date || date === 'Invalid date') return null
					return date
				})
				.filter(Boolean)
		}

		// startOfNextCurrentWeek() {
		// 	return this.moment().add(1, 'week').startOf('week').format('YYYY-MM-DD');
		// },

		// endOfNextCurrentWeek() {
		// 	return this.moment().add(1, 'week').startOf('week').add(4, 'day').format('YYYY-MM-DD');
		// }
	},

	methods: {
		moment,
		update() {
			console.log('update', this.selectedMonth)
			this.$refs.dialog.save(this.selectedMonth);
			this.selectedDay = moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD');
			this.updateDate()
			this.$store.dispatch('configurations/fetchSystemConfigValue')
		},

		getEntityNameByType,

		getEntityTypeName(entityTypeId) {
			return this.customersTypes.length ? this.customersTypes.find(c => c.id === entityTypeId)?.name : '';
		},

		getHoliday (date) {
			const vacationDayDetails = this.vacationsDayDetails
			this.isHoliday = getDateColor(date, this.vacations, { vacationDayDetails })
		},

		fetchEntities() {
			this.entitiesLoading = true;

			this.$store.dispatch('entities/fetchAll', {
				entityType: this.sheetData.directoryType,
				regionId: this.sheetData.regionId
			}).then(data => {
				this.entities = data;
			}).finally(() => {
				this.entitiesLoading = false;
			})
		},

		updateDate() {
			// if (!this.weeklyPlan || (this.weeklyPlan && !moment(this.selectedDay).isBetween(this.startOfNextCurrentWeek, this.endOfNextCurrentWeek, null, '[]'))) {
			this.$store.dispatch('plannedVisits/clear')
			this.loading = true;
			Promise.all([
				this.fetchVisits(true),
				this.fetchPlannedVisits(true),
				this.fetchAdministrativeDoubleVisits(),
			]).finally(() => {
				this.loading = false;
			})
			// } else if (this.weeklyPlan && moment(this.selectedDay).isBetween(this.startOfNextCurrentWeek, this.endOfNextCurrentWeek, null, '[]')) {
			// 	return ' '
			// }
		},

		fetchPlannedVisits(isFirsLoad = false) {
			this.$nextTick(() => {
				this.loading = true;

				const activePlan = this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === getWeekRange(this.selectedDay)?.start)

				return this.$store.dispatch('plannedVisits/fetchAll', {
					fromDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.start,
					toDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.end,
					visitPlanId: activePlan?.id || null,
					// fromDate: '2026-02-28'
				}).finally(() => {
					if (!isFirsLoad) this.loading = false;
				})
			})
		},

		fetchAdministrativeDoubleVisits() {
			const fromDate = !this.weeklyPlan
				? moment(this.selectedMonth, 'YYYY-MM').startOf('month').format('YYYY-MM-DD')
				: getWeekRange(this.selectedDay)?.start
			const toDate = !this.weeklyPlan
				? moment(this.selectedMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')
				: getWeekRange(this.selectedDay)?.end

			return this.$store.dispatch('plannedVisits/fetchPlannedDoubleVisits', {
				employeeId: this.self.employeeId,
				fromDate,
				toDate,
			}).then(data => {
				this.administrativeDoubleVisits = Array.isArray(data) ? data : []
			}).catch(() => {
				this.administrativeDoubleVisits = []
			})
		},

		isAdministrativeDoubleVisit(plannedVisit) {
			return !!plannedVisit?.isAdministrativeDouble
		},

		fillDateToEdit() {
			// FIXME remove if condition comment to activate edit
			// if (this.plannedVisitId) return;
			const plannedVisitData = this.getPlannedVisitById(this.plannedVisitId);
			this.sheetData.date = moment(plannedVisitData.date).format('YYYY-MM-DD');
			this.sheetData.regionId = this.allEntities.find(c => c.id === plannedVisitData.entity.entityId)?.entityAddresses[0].regionId || null;
			this.fetchEntities()
			this.sheetData.directoryType = this.plannedVisitId ? plannedVisitData.entity.entityTypeId : plannedVisitData.entity.entityTypeId;
			this.sheetData.entityId =
				this.plannedVisitId ? plannedVisitData.entity.entityId : [plannedVisitData.entity.entityId];

			if (useMaterialsPlan && plannedVisitData.plannedVisitMaterials) {
				plannedVisitData.plannedVisitMaterials.forEach((c, i) => {
					this.sheetData.plannedMaterials.push({
						id: i,
						materialId: c.materialId,
						amount: c.amount,
					})
				})
			}

			this.planningVisitSheet = true;
		},

		// async submit() {
		async submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				const actionName = this.plannedVisitId ? 'update' : 'create';
				/* const plan = this.plans.find(c => moment(c.fromDate).format('YYYY-MM') === this.selectedMonth);
				let visitPlanId = null;

				if (plan) {
					visitPlanId = plan.id;
				} else {
					await this.$store.dispatch('plans/create', {
						employeeId: this.self.employeeId,
						fromDate: moment().startOf('months').format('YYYY-MM-DD'),
						toDate: moment().endOf('months').format('YYYY-MM-DD')
					}).then((id) => {
						// visitPlanId = id;
						this.$store.dispatch('plans/fetchAll');
					})
				} */
				if (this.weeklyPlan) {
					console.log('this.selectedDay weekly plan', this.selectedDay)
					const startWeekOfSelectedDay = getWeekRange(this.selectedDay)?.start;

					if (!this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === startWeekOfSelectedDay)) {
						console.log('this.selectedDay weekly plan', this.selectedDay)
						await this.$store.dispatch('plans/create', {
							employeeId: this.self.employeeId,
							fromDate: startWeekOfSelectedDay,
							toDate: getWeekRange(this.selectedDay)?.end,
							isWeekly: Boolean(this.weeklyPlan)
						}).then((id) => {
							// visitPlanId = id;
							this.planCreatedId = id;
							this.$store.dispatch('plans/fetchAll');
						})
					} else {
						this.planCreatedId = this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === startWeekOfSelectedDay)?.id || null;
					}
				}
				const promises = [];
				[this.sheetData.entityId].flat().forEach(entityId => {
					promises.push(
						this.$store.dispatch(`plannedVisits/${actionName}`, {
							id: this.plannedVisitId,
							// FIXME use next line instead, NOT (const visitPlanId)
							visitPlanId: this.planCreatedId ? this.planCreatedId : this.activePlan.id,
							// visitPlanId: visitPlanId,
							entityId: entityId,
							date: this.sheetData.date,
							materialsAmount:
								useMaterialsPlan
									? this.sheetData.plannedMaterials.map(c => ({
										materialId: c.materialId,
										amount: c.amount,
									})).reduce((res, a) => {
										const index = res.findIndex(c => a.materialId === c.materialId);
										if (index === -1) res.push(a);
										else res[index].amount += a.amount;
										return res;
									}, [])
									: []
						})
					)
				})

				Promise.all(promises).then(() => {
					this.planningVisitSheet = false;
					this.fetchPlannedVisits();
					this.planCreatedId = null
				}).catch(() => {
					this.planCreatedId = null
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},

		// swipe card methods
		isPlannedVisitOutOfActivePlan(visitId) {
			const plannedVisitData = this.getPlannedVisitById(visitId);

			const startWeekDay = getWeekRange(this.selectedDay)?.start;

			const activePlan = this.weeklyPlan
				? this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === startWeekDay)
				: this.activePlan;

			const isCurrentWeek = moment(this.selectedDay).isBetween(this.startOfCurrentWeek, this.endOfCurrentWeek, null, '[]');
			if (this.weeklyPlan && isCurrentWeek) {
				return false;
			}

			if (activePlan && Object.keys(activePlan).length && plannedVisitData) {
				return moment(plannedVisitData.date)
					.isBetween(activePlan?.fromDate, activePlan?.toDate, 'days', '[]')
			} else {
				return false
			}
		},

		touchMove(event) {
			const offset = event.touchmoveX - event.touchstartX;
			this.touchSwipeOffset = offset > -50 && offset < 50 ? offset : Math.sign(offset) * 50;

			if (this.touchSwipeOffset === 50) {
				this.deleteButtonFab = true;
				this.editButtonFab = false;
			} else if (this.touchSwipeOffset === -50) {
				this.deleteButtonFab = false;
				this.editButtonFab = true;
			} else {
				this.deleteButtonFab = false;
				this.editButtonFab = false;
			}
		},
		endOffset() {
			if (this.touchSwipeOffset === 50) {
				this.$refs.DeleteDialog.activeDialog(this.plannedVisitId, 'plannedVisits');
			} else if (this.touchSwipeOffset === -50) {
				this.fillDateToEdit();
			}
			this.deleteButtonFab = false;
			this.editButtonFab = false;
		},

		/*
		addPlanningVisit() {
			if (this.$refs.form.validate()) {
				this.planningVisits.push({
					id: ++this.planningVisitsCounter,
					isInPlanningState: true,
					regionId: this.sheetData.regionId,
					entity: {
						id: this.sheetData.entityId,
						entityType: this.sheetData.directoryType,
						name: this.entities.find(c => c.id === this.sheetData.entityId).name,
					},
					date: this.sheetData.date,
				});

				this.planningVisitSheet = false;
			}
		},

		removePlanningVisit(id) {
			const index = this.planningVisits.findIndex(c => c.id === id);
			this.planningVisits.splice(index, 1);
			this.planningVisits.forEach((planningVisit, i) => {
				if (planningVisit > i) this.planningVisits[i].id -= 1;
			})
			this.planningVisitsCounter--;
		},
		*/
		async fetchVisits(isFirsLoad) {
			this.loading = true;

			return this.$store.dispatch('visits/fetchAllDueDates', {
				fromDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').startOf('months').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.start,
				toDate: !this.weeklyPlan ? moment(this.selectedMonth, 'YYYY-MM').endOf('months').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.end,
			}).then(data => {
				const getDate = (date) => moment(date).format('YYYY-MM-DD');

				const minifiedPlannedVisits =
					this.plannedVisits.map(c => ({ date: getDate(c.date), entityId: c.entityId }));

				this.notPlannedVisits =
					data.filter(c =>
						minifiedPlannedVisits.findIndex(e =>
							getDate(c.createdAt) === e.date &&
							c.entityId !== e.entityId
						) >= 0
					).map(c => ({ ...c, date: getDate(c.createdAt), isOutPlan: true }))
			}).finally(() => {
				if (!isFirsLoad) this.loading = false;
			})
		},

		goToTodayDate() {
			const currentMonth = moment().format('YYYY-MM');
			this.selectedDay = moment().format('YYYY-MM-DD');

			if (this.selectedMonth !== currentMonth) {
				this.selectedMonth = moment().format('YYYY-MM');

				this.loading = false;
				Promise.all([
					this.fetchPlannedVisits(true),
					this.fetchVisits(true),
					this.fetchAdministrativeDoubleVisits(),
				]).finally(() => {
					this.loading = false;
				})
			}
		}
	},

	created() {
		/*
		if ('planning-visits' in localStorage) {
			this.planningVisits = JSON.parse(localStorage.getItem('planning-visits'));
			this.planningVisitsCounter = this.planningVisits.length;
		} else {
			promises.push(this.$store.dispatch('plans/fetchAll'));
		}
		*/
		if (this.$route.query.date) {
			this.selectedDay = this.$route.query.date;
			this.selectedMonth = moment(this.$route.query.date).format('YYYY-MM');
		}

		// let isDateInActivePlanRange;
		this.loading = true;
		Promise.all([
			this.fetchPlannedVisits(true),
			this.fetchVisits(true),
			this.fetchAdministrativeDoubleVisits(),
			this.$store.dispatch('regions/fetchAll'),
			this.$store.dispatch('plans/fetchAll'),
			this.$store.dispatch('entities/fetchEntityType').then(() => {
				this.$store.dispatch('configurations/fetchEnum').then(() => {
					this.$store.dispatch('configurations/fetchAll')
				})
			}),
			this.$store.dispatch('configurations/fetchSystemConfigValue'),

			// 	? this.$store.dispatch('plans/fetchAll')
			// 	: null,

			// materials
			useMaterialsPlan && !this.allMaterials.length
				? this.$store.dispatch('materials/fetchAll', {})
				: null,

			// !this.vacations.length
			// 	? this.$store.dispatch('vacations/fetchAll')
			// 	: null,
			!this.customersTypes.length ? this.$store.dispatch('entities/fetchEntityType') : null,
			this.$store.dispatch('entities/fetchAll', {})
		]).then((data) => {
			// isDateInActivePlanRange = !this.weeklyPlan
			// 	? moment(moment()).isBetween(this.activePlan?.fromDate, this.activePlan.toDate, 'days', '[]')
			// 	: moment(moment()).isBetween(this.activePlan?.fromDate, this.activePlan.toDate, 'days', '[]');
			// const selectedDay = getWeekRange(this.selectedDay)?.start;

			// if (!this.plans.length || !this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === moment(selectedDay).format('YYYY-MM-DD'))) {
			// 	this.$store.dispatch('plans/create', {
			// 		employeeId: this.self.employeeId,
			// 		fromDate: !this.weeklyPlan ? moment().add(1, 'months').startOf('months').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.start,
			// 		toDate: !this.weeklyPlan ? moment().add(1, 'months').endOf('months').format('YYYY-MM-DD') : getWeekRange(this.selectedDay)?.end,
			// 	}).then(() => {
			// 		this.$store.dispatch('plans/fetchAll').finally(() => {
			// 			this.loading = false;
			// 		})
			// 	})
			// }
			this.allEntities = data[data.length - 1]
		}).finally(() => {
			console.log('lockPlanBeforeDays', this.lockPlanBeforeDays)
			const selectedDay = getWeekRange(this.selectedDay)?.start;
			if (this.plans.length > 0 || !this.plans.find(c => moment(c.fromDate).format('YYYY-MM-DD') === moment(selectedDay).format('YYYY-MM-DD'))) this.loading = false;
		})
	}
};
</script>

<style lang="scss">
#plans {
	overflow: hidden;
	.v-slide-group {
		&__prev, &__next {
			min-width: 30px;
		}
	}
	.planned-visit {
		&__container {
			display: flex;
			margin-bottom: .5rem;
			align-items: center;
			position: relative;
		}
		&__card {
			z-index: 1;
			flex-grow: 1;
			transition: all .4s ease;
		}
		&__action-btn {
			z-index: 0;
		}
	}
}

	.sale-system-add-fab {
		margin-bottom: 110px !important;
	}
</style>
